export type AudienceLevel =
  | 'individual-contributor'
  | 'new-manager'
  | 'mid-level'
  | 'senior-leader'
  | 'c-suite'

export interface SkillModule {
  id: string
  courseId: string
  name: string
  category: string
  description: string
  relevance: string
  topics: string[]
  outcomes: string[]
  durationHours: number
  levels: AudienceLevel[]
  keywords: string[]
}

export interface MatchedModule {
  module: SkillModule
  score: number | null
  matchedTerms: string[]
}

export interface PathwayTemplate {
  id: string
  name: string
  audience: AudienceLevel
  summary: string
  terms: string[]
  moduleIds: string[]
}

export interface Cohort {
  id: string
  name: string
  organization: string
  size: number
  level: AudienceLevel
}

export interface SavedPathway {
  id: string
  name: string
  organization: string
  audience: AudienceLevel
  cohortId: string | null
  moduleIds: string[]
  /** ISO date, used for sorting. */
  updatedAt: string
  updatedLabel: string
}

/**
 * How the rep's current edits relate to the pathway they opened.
 * 'none' means they are building something new from scratch.
 */
export type EditMode = 'none' | 'updating'

export interface ConversationRead {
  /** Every theme detected in the notes, strong and weak together. */
  terms: string[]
  /** Clear, repeated signals — switched on by default. */
  strong: string[]
  /** Mentioned once or ambiguously — offered, not applied. */
  weak: string[]
  level: AudienceLevel | null
  headcount: number | null
  /** Account name detected in the notes, if the rep mentioned one. */
  company: string | null
}

export const LEVEL_LABELS: Record<AudienceLevel, string> = {
  'individual-contributor': 'Individual contributors',
  'new-manager': 'New managers',
  'mid-level': 'Mid-level leaders',
  'senior-leader': 'Senior leaders',
  'c-suite': 'C-suite',
}

export const LEVEL_ORDER: AudienceLevel[] = [
  'individual-contributor',
  'new-manager',
  'mid-level',
  'senior-leader',
  'c-suite',
]


